<template>
  <div class="comp-loader" :class="{ fullscreen: fullscreen, small }">
    <div>...</div>
  </div>
</template>

<script>
  export default {
    name: 'Loader',
    //---------------------------------------------------
    //
    //  Properties
    //
    //---------------------------------------------------
    props: {
      fullscreen: {
        type: Boolean,
        default: false,
      },
      small: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>

<style lang="scss">
  @import '~scss/mixins';
  @import '~scss/variables';

  .comp-loader {
    overflow: hidden;
    &.fullscreen {
      width: 100%;
      height: 100vh;
      position: fixed;
      top: 0;
      left: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      background: $color-black-alpha-05;
      z-index: 1000;
      pointer-events: none;
    }
    & > div {
      margin: 0 auto;
      font-size: 5px;
      position: relative;
      text-indent: -9999em;
      border-top: 1.1em solid $color-black-alpha-20;
      border-right: 1.1em solid $color-black-alpha-20;
      border-bottom: 1.1em solid $color-black-alpha-20;
      border-left: 1.1em solid $color-black-alpha-10;
      transform: translateZ(0);
      animation: roundrobin 1.1s infinite linear, pulsate 1.5s infinite linear;
      width: 50px;
      height: 50px;
      overflow: hidden;

      &, &:after {
        border-radius: 50%;
      }
    }
    &.small > div {
      width: 24px;
      height: 24px;
      border-width: 0.5em;
    }
  }
  @keyframes roundrobin {
    0%   { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  @keyframes pulsate {
    0%   { border-left-color: rgba(0, 0, 0, 0.2); }
    50%  { border-left-color: rgba(0, 0, 0, 1); }
    100% { border-left-color: rgba(0, 0, 0, 0.2); }
  }
</style>
